import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-help',
  templateUrl: './step-help.component.html',
  styleUrls: ['./step-help.component.scss'],
})
export class StepHelpComponent implements OnInit {

  public helpSections: any[] = [];

  constructor() {
    this.helpSections = [
      {
        "title": "What is a quiz?",
        "description": "A quiz is a collection of multiple choice questions used to test the knowledge of your learners. A quiz can be made up of a maximum of 15 questions along with an optional introduction, confirmation and results page.",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "What is a single question?",
        "description": "A single question is similar to a quiz but is made up to only one multiple choice question. It does not have an introduction, confirmation or results page. ",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "What is the difference between a quiz and a single question?",
        "description": "The main difference between a quiz and a single question, is that a quiz is made of up to 15 questions whereas a single question contains just one question. Furthermore, single questions do not have the options for an introduction, confirmation or results page. ",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "How do I edit the quiz details?",
        "description": "To edit the quiz details, select the 'Quiz Details' option in step 1. This will display the general quiz details. These properties effect the look and feel of the entire quiz.",
        "subSections": [
          {
            "title": "What is the 'Is this quiz visible' property?",
            "description": "The 'Is this quiz visible' property is used to hide the quiz from learners. This is to allow you to add another media into the scene which would be triggered to display the quiz through Media Actions. ",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the 'Enable text-to-speech' property?",
            "description": "The 'Enable text-to-speech' property is used to enable text-to-speech capabilities on introduction, confirmation and result pages. A speaker icon will appear at the side of the quiz to play a verbal version of the text on the page of the quiz currently displayed to the learner.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the 'Pass score' property?",
            "description": "The 'Pass Score' property is the total number of question points required to pass the quiz. For example, If there are two questions both worth 2 points, I can set the Pass Score property to be 2. This would mean that the learner is required to get one question right in order to pass the quiz. ",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the 'Is background visible' property?",
            "description": "The 'Is background visible' property is used to control whether the background should be displayed on the quiz. ",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the 'Quiz scale' property?",
            "description": "The 'Quiz scale' property is used to scale the entire size of the quiz up or down. ",
            "subSections": [],
            "collapsed": true
          }
        ],
        "collapsed": true
      },
      {
        "title": "What are quiz actions?",
        "description": "Quiz actions allow you to set actions to occur when certain conditions are met as the result of learner interactions. For example, on a quiz I could have an image appear when the learner passes or fails a quiz. ",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "What is the Introduction page?",
        "description": "The introduction page is the first page on a quiz. This page allows you to add a title and description to the first page. For example this can be used to brief the learner on the quiz and/or set up any instructions for the learner.",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "How do I edit the question details?",
        "description": "To edit the question details, select a question from step 2. This allows you to edit all the details of a question in the quiz.",
        "subSections": [
          {
            "title": "What are the different question types?",
            "description": "There are two different types of question. There are Standard questions and Media questions. Media questions allow you to attach media to the answers in a question. The standard questions do not allow you to do this and instead rely on text to be used in the answers.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What are question actions?",
            "description": "Question actions allow you to set actions when certain conditions occur when a user interacts with the question. An example of this is adding an image to appear to the learner if they get the question correct.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What are answer actions?",
            "description": "Answer actions allow you to set actions when certain conditions occur when a user interacts with an answer on a question. An example of this is that when a user select answer B, the question will restart.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What are the question points for?",
            "description": "The question points are the number of points available for this question if the learner gets it correct. ",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the correct and incorrect feedback for?",
            "description": "The correct and incorrect feedback is used to display text feedback to the learner when they submit the question.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "How is the correct and incorrect feedback displayed to the learner?",
            "description": "The correct and incorrect feedback is displayed across the bottom half of the quiz above the question number navigation. If the correct feedback is displayed it has a green border. If the incorrect feedback is displayed it has a red border.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "For the Media question type, how do i attach media to answers?",
            "description": "To attach media to answers, the question type must be set to Media. Next to each of the answers, there is an 'Add Media' button which will display the answer media section. From this section you can upload media, select existing media, preview, edit the properties of the media and remove the media on the answer.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What media can be attached to answers?",
            "description": "The media that can be attached to answers are videos, images, audio and also link to a scene. The videos, images and audios can be selected from existing media or upload new media.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What does enabling the text-to-speech property do on questions?",
            "description": "The 'Enable text-to-speech' property is used to enable the text-to-speech capability for all the questions. A speaker icon will appear at the side of the quiz to play a verbal version of the text on the question currently displayed to the learner.",
            "subSections": [],
            "collapsed": true
          }
        ],
        "collapsed": true
      },
      {
        "title": "What is the confirmation page?",
        "description": "The Confirmation Page is an additional optional page that can be displayed to the learner. This page is displayed to the learner once they have submitted all the questions in the quiz. In the confirmation page, you can add a title and also confirmation text for complete and incomplete questions. For example, the incomplete confirmation text can be used to warn to the learner that they have not selected answers for all questions within the quiz.",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "What is the results page?",
        "description": "The results page is an additional optional page that can be displayed to the learner. This page is displayed once the learner has submitted their answers in the quiz. This will display their score as well as a title and pass or fail messages. These messages can be edited by you. ",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "How do I view the results of a learner?",
        "description": "In order for you to view the results of quizzes and single questions within a project, you can download the xAPI report from the projects menu. Furthermore, you can also see the results in the Daily Report for learners who have done the quiz or single question.",
        "subSections": [],
        "collapsed": true
      }
    ];
  }

  ngOnInit() { }

  toggleCollapseHelpSection(index: number) {
    this.helpSections[index].collapsed = !this.helpSections[index].collapsed;
  }

  toggleCollapseSubHelpSection(index: number, subIndex: number) {
    this.helpSections[index].subSections[subIndex].collapsed = !this.helpSections[index].subSections[subIndex].collapsed;
  }
}
